export const errors = {
  100: {
    message: '不明なエラーです',
    supplement: '予期しない原因不明のエラーが発生しました\nホーム画面へ戻ります'
  },
  200: {
    message: '通信エラーです',
    supplement: '通信に失敗しました\n通信環境を整えてから再度お試しください'
  },
  201: {
    message: 'このページは表示できません',
    supplement: 'ページの読み込みに失敗しました\n通信環境を整えてから再度お試しください'
  },
  300: {
    message: 'ただいまメンテナンス中です',
    supplement: 'お客様には大変ご不便をおかけしております\n' +
      '申し訳ございませんがメンテナンス終了まで\n今しばらくの間お待ちください\n\n' +
      '▼メンテナンス終了予定時刻\n' +
      '【YYYY年MM月DD日(W) hh:mm】\n\n' +
      'なおメンテナンス終了時刻につきましては\n予告なく変更する場合がございます\n' +
      '予めご了承のほどお願い申し上げます\n\n' +
      '「プリクラON」運営チーム'
  },
  400: {
    message: '認証エラーです',
    supplement: 'このSNSアカウントは認証できませんでした\n\n別の方法でログインしてください'
  },
  401: {
    message: 'アカウント登録が\n正常に完了していません',
    supplement: 'アカウント登録が中断されました\nアカウント登録を最初からやり直してください'
  },
  402: {
    message: 'アカウント登録URLへの\nアクセス有効期限が切れています',
    supplement: 'この登録URLは\n有効期限が過ぎているため使用できません\n再度アカウント登録を最初からお試しください'
  },
  403: {
    message: 'このアカウント登録URLは無効です',
    supplement: '登録URLが再発行されたため\nこの登録URLは使用できません\n\n最新の返信メールをご確認ください'
  },
  404: {
    message: 'このメールアドレスでは登録できません',
    supplement: ''
  },
  405: {
    message: 'このパスワードでは登録できません',
    supplement: ''
  },
  406: {
    message: 'このニックネームでは登録できません',
    supplement: ''
  },
  407: {
    message: 'この生年月では登録できません',
    supplement: ''
  },
  408: {
    message: '無料会員削除が正常に完了できませんでした',
    supplement: 'お手数をお掛けしますが、以下のご確認をお願いします。\n' +
      '\n' +
      '・有料会員の有効期間中である\n' +
      '有料会員の有効期間が終了してから再度お試しください\n' +
      '\n' +
      '・会員情報に不整合が生じている\n' +
      '一度ログアウトしていただき、再度ログインしてからお試しください\n' +
      '\n' +
      '上記で解決しない場合、お手数をおかけいたしますが\nお問い合わせフォームにエラー表示を記載の上\nユーザサポートへお問い合わせください。'
  },
  409: {
    message: '無料会員削除が完了していません',
    supplement: ''
  },
  410: {
    message: '正しいメールアドレスとパスワードを入力してください。',
    supplement: ''
  },
  411: {
    message: 'アカウントロック',
    supplement: 'パスワード入力間違いが規定回数に達しました\n不正ログイン防止のため\nアカウントをロックしました\n' +
      'ロック解除方法などの詳細については\nこちらをご覧ください'
  },
  412: {
    message: 'ログインを解除しました',
    supplement: '最終ログイン日時から長期間経過、\nもしくはパスワードを変更した場合、\n不正利用を防ぐため自動的にログアウトします。\n' +
      'ご不便をおかけいたしますが改めてログインを行ってください。'
  },
  413: {
    message: 'ログアウトできませんでした',
    supplement: ''
  },
  420: {
    message: 'シールを取得できませんでした',
    supplement: ''
  },
  421: {
    message: '表示可能なシールがありません',
    supplement: ''
  },
  422: {
    message: 'シールIDが正しくありません。シールに記載されている15桁の数字を入力してください。',
    supplement: ''
  },
  423: {
    message: 'シールIDではありません',
    supplement: 'シールのIDではありません\nシールに記載されている\n15桁の番号を入力してください'
  },
  424: {
    message: 'ダウンロード期限が切れています',
    supplement: '保存期間が切れているため\nダウンロードできませんでした'
  },
  425: {
    message: 'ダウンロード回数を超えています',
    supplement: 'このシールのダウンロード回数が\n規定回数を超えているため\nダウンロードできませんでした'
  },
  426: {
    message: 'すでにダウンロード済みのシールです',
    supplement: 'このシールはすでに\nダウンロードされています'
  },
  427: {
    message: 'シールをダウンロードできません',
    supplement: 'お客様は利用規約に違反されたため\nシールをダウンロードできません\n利用規約の「禁止行為」をご確認ください'
  },
  430: {
    message: '画像データの取得に失敗しました',
    supplement: ''
  },
  431: {
    message: '表示できるプリクラがないよ！',
    supplement: 'SEGAのプリ機で撮ったプリクラを「プリダウンロード」からダウンロードしてね'
  },
  432: {
    message: 'この画像は\nすでにアルバムから削除されています',
    supplement: ''
  },
  439: {
    message: 'iOS13以前のスマホでは\n動画のダウンロードが出来ません\n' +
      'iOS13にアップデートして頂くか\nアプリ版「プリクラON」をご利用下さい',
    supplement: ''
  },
  440: {
    message: '会員証の取得に失敗しました',
    supplement: ''
  },
  441: {
    message: '会員証の再生成に失敗しました',
    supplement: ''
  },
  442: {
    message: 'この会員証は利用期限を\n過ぎているため使えません',
    supplement: '会員証の再表示を行って\n新しい会員証を作成してください'
  },
  450: {
    message: '有料会員登録が正常に完了していません',
    supplement: '通信途絶など予期しない原因により\n有料会員登録が中断されました' +
      'お手数ですがお問い合わせフォームに\nエラーの内容と番号を記載の上\nユーザサポートへお問い合わせください'
  },
  451: {
    message: '有料会員の解約が完了していません',
    supplement: ''
  },
  452: {
    message: '有料会員の解約が\n正常に完了できませんでした',
    supplement: '通信途絶など予期しない原因のため\n有料会員登録状態に不整合が発生しています\n\n' +
      'お手数ですがお問い合わせフォームに\nエラーの内容と番号を記載の上\nユーザサポートへお問い合わせください'
  },
  460: {
    message: 'お知らせデータの取得に失敗しました',
    supplement: ''
  },
  461: {
    message: '表示可能なお知らせがありません',
    supplement: ''
  },
  470: {
    message: 'クーポンデータの取得に失敗しました',
    supplement: ''
  },
  471: {
    message: '表示可能なクーポンがありません',
    supplement: ''
  },
  472: {
    message: 'クーポン利用履歴の取得に失敗しました',
    supplement: ''
  },
  473: {
    message: '表示可能な\nクーポン利用履歴がありません',
    supplement: ''
  },
  474: {
    message: 'このクーポンは利用期限を過ぎています',
    supplement: 'このクーポンは利用期限を過ぎているため\n利用することができません'
  },
  480: {
    message: 'プリもっとデータの取得に失敗しました',
    supplement: ''
  },
  481: {
    message: 'この相手のお名前では登録できません',
    supplement: ''
  },
  482: {
    message: 'このメッセージでは登録できません',
    supplement: ''
  },
  483: {
    message: 'この画像は登録できません',
    supplement: ''
  },
  484: {
    message: 'プリもっとの保存に失敗しました',
    supplement: 'プリもっとデータが\n破損している可能性があります\n\n' +
      'お手数ですがお問い合わせフォームに\nエラーの内容と番号を記載の上\nユーザサポートへお問い合わせください'
  },
  485: {
    message: 'プリもっとが保存できませんでした',
    supplement: ''
  },
  486: {
    message: 'このプリもっとは使用中です',
    supplement: 'このプリもっとは\n現在プリ機で使用中のため再編集できません'
  },
  487: {
    message: 'プリもっと購入履歴の\n取得に失敗しました',
    supplement: ''
  },
  488: {
    message: '表示可能な\nプリもっと購入履歴がありません',
    supplement: ''
  },
}
